// extracted by mini-css-extract-plugin
module.exports = {"product-card":"price_product-card___rEQy","price":"price_price__VD5u5","tax_message":"price_tax_message__0BAta"};